export type SettledResult<T> =
  | { ok: true; value: T }
  | { ok: false; error: unknown }

/** Await a promise without a `catch` keyword (network errors → `{ ok: false }`). */
export function settled<T>(promise: Promise<T>): Promise<SettledResult<T>> {
  return promise.then(
    (value) => ({ ok: true as const, value }),
    (error: unknown) => ({ ok: false as const, error }),
  )
}
